// extracted by mini-css-extract-plugin
export default {"input":"ye4eX","inputRoot":"p1xdC","label":"bPzr3"};